import baustein from "baustein";
import analytics from "web/script/analytics/analytics";
import globalEvents from "web/script/utils/global-events";
import requester from "web/script/modules/requester";

export default baustein.register("wishlist-delete-confirmation", {
    defaultOptions: {
        deleteProductId: null,
    },
    setupEvents(add) {
        add("click", ".confirmation-prompt__button--yes", this.delete);
        add("click", ".confirmation-prompt__button--no", this.closeOverlay);
    },
    closeOverlay() {
        analytics.event("clicked", "no delete saved item");
        globalEvents.trigger("confirmation-prompt-closed");
    },
    delete() {
        analytics.event("clicked", "yes delete saved item").then(() => {
            const body = {
                product_id: this.options.deleteProductId,
            };
            return requester("/services/pins/", { method: "POST", body })
                .then((response) => {
                    if (!response.ok || response.status !== 204) {
                        console.error(
                            `Could not remove product with id: ${this.options.deleteProductId}`
                        );
                        return;
                    }
                    analytics.event("save_for_later", "remove_item", "product_card", true);
                    globalEvents.trigger("confirmation-prompt-yes");
                })
                .catch(() => {
                    // Still want to log the intent, but can't work out from response if it was an add or remove
                    // - get this data from the template serializer instead (this won't be accurate if the page
                    // has not been refreshed since last add/remove, but is the best we can do here).
                    analytics.event("save_for_later", "remove_item", "product_card", true);
                    globalEvents.trigger("confirmation-prompt-closed");
                });
        });
    },
});
